import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse, JobInternalConfig } from "@/types";

export function useGetJobInternalConfig() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  return useQuery({
    queryKey: ["job-internal-configs", currentCompanyId, currentJobId],
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/job-internal-configs`;
      const res = await guacHttpClient.get<
        JobInternalConfig,
        HttpResponse<JobInternalConfig>
      >(path);
      return res.data;
    },
  });
}
